import { ReportScreen } from '../reports/ReportScreen';

/** Route glue only: the screen body lives in `screens/reports/` (ticket 12 zone). */
export default function TrialBalanceScreen(): JSX.Element {
  return <ReportScreen kind="trial-balance" />;
}
